import request from '@/util/request';

// 各种指标数据
export const getMetricsDataApi = (params, options) =>
  request.get('/api/v4ward/plan/page', Object.assign({}, options, { params }));
